import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@/lib/apiClient";
import { cn } from "@/lib/utils";

interface UsuarioResumoApi {
  id: number;
  login: string;
  nome: string;
}

interface UsuarioNomeProps {
  /** Id do usuário do sistema (operador, aprovador, responsável...). */
  id?: number | null;
  /** Acrescenta o login entre parênteses. */
  comLogin?: boolean;
  vazio?: string;
  className?: string;
}

/**
 * Exibe o nome de um usuário a partir do id (`GET /api/cadastros/usuarios/{id}`).
 * Sem permissão de ler usuários a API responde 403: mostra "(usuário)" em vez do id.
 */
export function UsuarioNome({ id, comLogin = false, vazio = "—", className }: UsuarioNomeProps) {
  const { data, isLoading, isError } = useQuery({
    queryKey: ["usuario", id],
    queryFn: async () => (await apiClient.get<UsuarioResumoApi>(`/api/cadastros/usuarios/${id}`)).data,
    enabled: !!id,
    staleTime: 5 * 60_000,
    retry: false,
  });

  if (!id) return <span className={cn("text-muted-foreground", className)}>{vazio}</span>;
  if (isLoading) return <span className={cn("text-muted-foreground", className)}>…</span>;
  if (isError || !data) return <span className={cn("text-muted-foreground italic", className)}>(usuário)</span>;

  const texto = comLogin && data.login && data.login !== data.nome ? `${data.nome} (${data.login})` : data.nome;
  return <span className={className} title={data.login}>{texto}</span>;
}
